/**************************************************
 * Nombre:       Seccion_Escuelas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Oferta_Edutavita from "./Componentes/Home_Oferta_Edutavita";
import Home_PorQue_Elejirnos from "./Componentes/Home_PorQue_Elejirnos";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Escuelas_Portada from "./Componentes/Escuelas_Portada";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Seccion_Escuelas = () => {
    const {sCell} = useResponsive()

    useEffect(() => {
        irArriba()
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? -1 : 0}}>
                <Escuelas_Portada/>
            </Grid>

            <Grid id={'catalogo'} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: 10}}>
                <Home_Oferta_Edutavita/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 14}}>
                <Home_PorQue_Elejirnos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 18}}>
                <Home_Testimonios/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Escuelas